import actions from '@/core/store/item-pedido/estorno/estornar/actions'
import state from '@/core/store/item-pedido/estorno/estornar/state'
import mutations from '@/core/store/item-pedido/estorno/estornar/mutations'

export default { actions, state, mutations }
